import React, { useEffect, useState } from 'react'
import { signOut } from '../../../api/auth'
import { Navigate, useNavigate } from 'react-router-dom'
import { ROUTES } from '../../../router/routes'
import { setAuthenticated } from '../../../store/actions/authActions'
import { useDispatch, useSelector } from 'react-redux'

export const Logout = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const readRegForLogoutSignal = localStorage.getItem('forceLogin')

    signOut().then(() => {
        dispatch(setAuthenticated(false))

        // this is only for the case where product was originally called with a forceLogin query parameter, forcing a specific user (monday.com usecase)
        if (readRegForLogoutSignal) {
            navigate(ROUTES.LOGIN)
        }

        navigate(ROUTES.INSIGHTS)
    })
}
